export const isFECReportsEnabled = (countryId?: string): boolean => {
  return countryId === 'FR'
}
